export const passwordRegex = new RegExp(/[a-zA-Z\d]{8,}/)
export const activePasswordRegex = new RegExp(/[a-zA-Z\d]{8,}/)
export const activeEmailRegex = new RegExp(/^[\w@\._-]{0,50}$/)
export const activePhoneRegex = new RegExp(/^\d+$/)
export const fullNameRegex = new RegExp(/.{2,} .{2,}/)
export const phoneRegex = new RegExp(/^05\d+$/)
export const hebrewAndSpecialCharsRegex = new RegExp(/^[\u0590-\u05FF0-9]+[\u0590-\u05FF0-9 ,./:!()\\|?'"-]*$/);
export const hebrewFullNameRegex = new RegExp(/^[\u0590-\u05FF]{2,}[\u0590-\u05FF '"]* [\u0590-\u05FF]{2,}[\u0590-\u05FF '"]*$/);
export const urlRegex = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi);
export const numbersRegex = new RegExp(/^[1-9]+[0-9]*$/);
export const numberStringRegex = new RegExp(/^[0-9]+$/);
export const heTextRegex = new RegExp(/^[-,'"\.\d א-ת()]*$/);
export const hebrewRegex = new RegExp(/^[-' א-ת]{2,} [-' א-ת]{2,}$|^$/);
export const base64ImageRegex = new RegExp(/data:image\/(jpeg|png|jpg);base64/g);
export const httpRegex = new RegExp("^(http|https)://");
export const confirmRegex = new RegExp(/confirm.*/g);
export const englishNoSpacesRegex = new RegExp(/^[A-Za-z0-9_]+$/);